Controller.$inject = [];

function Controller() {
    let self = this;

    let previousFrom, previousTo;
    let changesCounter = 0;

    self.internalModel = {
        value1: null,
        value2: null
    };

    self.handleInternalChange = () => {
        let ignoreChangesCount = 0;

        if (isNaN(self.ngModelFrom)) {
            ignoreChangesCount++;
        }

        if (isNaN(self.ngModelTo)) {
            ignoreChangesCount++;
        }

        if (changesCounter >= ignoreChangesCount) {
            const {value1, value2} = self.internalModel;
            self.ngModelFrom = Math.min(value1, value2);
            self.ngModelTo = Math.max(value1, value2);
            previousFrom = self.ngModelFrom;
            previousTo = self.ngModelTo;
        }

        updateFilledWidths(self.internalModel.value1, self.internalModel.value2);
        changesCounter++;
    };

    const updateFilledWidths = (from, to) => {
        const rangeDistance = self.max - self.min;
        let thumbStart = Math.min(from, to);
        let thumbEnd = Math.max(from, to);

        self.filledEdgeStart = ((thumbStart - self.min) / rangeDistance) * 100;
        self.filledEdgeEnd = ((self.max - thumbEnd) / rangeDistance) * 100;
    };

    const updateInternalModel = () => {
        if (!isNaN(self.ngModelFrom)) {
            self.internalModel.value1 = self.ngModelFrom;
        }
        if (!isNaN(self.ngModelTo)) {
            self.internalModel.value2 = self.ngModelTo;
        }
    };

    self.$onInit = () => {};

    self.$onChanges = (changes) => {

    };

    self.$doCheck = () => {
        if ((self.ngModelFrom && (previousFrom !== self.ngModelFrom)) || (self.ngModelTo && (previousTo !== self.ngModelTo))) {
            updateInternalModel();
            updateFilledWidths(self.ngModelFrom, self.ngModelTo);
            previousFrom = self.ngModelFrom;
            previousTo = self.ngModelTo;
        }
    }

}

export function HuiInputSliderRange() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            ngModelFrom: '=',
            ngModelTo: '=',
            min: '<',
            max: '<',
            step: '<',
            color: '@',
            hNameInputOne: '@',
            hNameInputTwo: '@',
            sizing: '@'
        },
        transclude: true,
        controller: Controller,
        controllerAs: '$huiCtrl',
        template: ($element, $attrs) => {
            return `
                <div class="hui hui-input-slider"
                     role="slider"
                     aria-valuetext="{{ $huiCtrl.ngModelFrom }} - {{ $huiCtrl.ngModelTo }}"
                     ng-class="['hui-' + ($huiCtrl.color || 'accent'),
                                $huiCtrl.sizing || 'md']">
                    <div class="hui-input-slider-track">
                        <div class="hui-input-slider-filled range-filled" 
                             ng-class="['hui-' + ($huiCtrl.color || 'accent')]"
                             ng-style="{ 
                                left: $huiCtrl.filledEdgeStart + '%',
                                right: $huiCtrl.filledEdgeEnd + '%'
                             }">
                             <div class="hui-input-slider-thump slider-thump-from" 
                                   ng-class="['hui-' + ($huiCtrl.color || 'accent')]"></div>
                             <div class="hui-input-slider-thump" 
                                   ng-class="['hui-' + ($huiCtrl.color || 'accent')]"></div>
                        </div>
                    </div>
                     <input type="range" min="{{$huiCtrl.min}}" max="{{$huiCtrl.max}}" step="{{$huiCtrl.step}}" 
                            name="{{$huiCtrl.hNameInputOne}}"
                            class="hui-slider-input dual-input" 
                            ng-model="$huiCtrl.internalModel.value1" 
                            ng-change="$huiCtrl.handleInternalChange()" />      
                     <input type="range" min="{{$huiCtrl.min}}" max="{{$huiCtrl.max}}" step="{{$huiCtrl.step}}" 
                            name="{{$huiCtrl.hNameInputTwo}}"
                            class="hui-slider-input dual-input hui-slider-input-right" 
                            ng-model="$huiCtrl.internalModel.value2" 
                            ng-change="$huiCtrl.handleInternalChange()" />      
                </div>
            `;
        }
    };
}
